import { VendorRepresentative } from './models';

export type NewUserSchema = {
  firstName: string;
  lastName: string;
  email: string;
  readOnlyAccess: boolean;
  projectId?: string;
};

export type UpdatedUserInput = {
  firstName?: string;
  lastName?: string;
};

export interface AuthUser {
  auth_time: number;
  client_id: string;
  event_id: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  origin_jti: string;
  scope: string;
  sub: string;
  token_use: string;
  username: string;
}

export interface DeleteUserInput {
  vendorId: string;
  vendorRepresentativeId: string;
}

export interface DeleteUserData {
  userToDelete: DeleteUserInput;
  user: VendorRepresentative;
}

export enum UserRoles {
  VENDOR_TL = 'NVIEW:VendorTeamLead',
  VENDOR_VIEWER = 'NVIEW:VendorViewer',
  ADMIN = 'NVIEW:Admin',
  VIEWER = 'NVIEW:Viewer',
}
